<template>
  <v-autocomplete
    v-model="selectedPagamentos"
    label="Forma de Pagamento"
    :items="arrayPagamentos"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedPagamentos.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";

export default {
  name: "SelectFormaPagamento",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      arrayPagamentos: ["Consorcio", "AVista", "CDC"],
      selectedPagamentos: [],
      icon: "",
      rules: rules
    };
  },

  methods: {
    selectAll(all = true) {
      if (all) {
        this.selectedPagamentos = this.arrayPagamentos;
      } else {
        this.selectedPagamentos = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedPagamentos);
    }
  }
};
</script>
